
import { DanglingDossierDb } from "@/models/dangling-dossier-db";
import { DbInfo } from "@/models/db-info";
import { MetricService } from "@/services";
import { ServerService } from "@/services/server-service";
import { toDateString } from "@/utils/strings";
import Vue from "vue";
import { IDataTableColumn } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			dbInfo: null as null| DbInfo,
			dbs: [] as DanglingDossierDb[],
			selectedItems: [] as DanglingDossierDb[],
			dbId: -1,
			isDeleting: false,
			isFetching: false
		};
	},
	computed: {
		serverName():string {
			if (!this.dbInfo) return "";
			return this.dbInfo.toString();
		},
		// eslint-disable-next-line max-lines-per-function
		tableColumns():IDataTableColumn[] {
			return [
				{
					name: "Dossier",
					property: "dossierId",
					print(v:number, dossier:DanglingDossierDb):string{
						if (dossier.dossierName) {
							return `${v} (${dossier.dossierName})`;
						}
						return `${v}`;
					},
					width: "200px",
				},
				{
					name: "Account",
					property: "companyId",
					print(v:number, dossier:DanglingDossierDb):string{
						if (v == 0) {
							return "Niet gevonden";
						}
						if (dossier.companyName) {
							return `${v} (${dossier.companyName})`;
						}
						return `${v}`;
					},
					width: "200px",
				},
				{
					name: "Actief tot",
					property: "activeUntil",
					print(v:null | Date, dossier:DanglingDossierDb){
						if (dossier.companyId == 0) {
							return "";
						}
						if (!v){
							return "Permanent";
						}
						if (v.getTime() < new Date().getTime()) {
							return `Vervallen (${toDateString(v)})`;
						}
						return toDateString(v);
					},
					width: "200px"
				},
				{
					name: "Reden",
					property: "deletionReasons",
					print(v:string[]){
						return v.join("<br/>");
					},
					width: "500px"
				}
			];
		},
		infoDisabled():boolean{
			let item = this.selectedItems[0];
			if (!item) return true;
			if (!item.companyId) return true;
			return false;
		},
		deleteDisabled():boolean{
			let item = this.selectedItems[0];
			if (!item) return true;
			if (this.isDeleting) return true;
			return false;
		}
	},
	watch: {
		"selectedItems.length"(){
			if (this.selectedItems.length < 2){
				return;
			}
			this.selectedItems = this.selectedItems.splice(0, this.selectedItems.length-2);
		}
	},
	methods: {
		async fetch(){
			if (this.isFetching) return;
			try{
				this.isFetching = true;
				this.dbs = await ServerService.dbService.getDanglingDbs(parseInt(this.$route.params.id));
			}catch(err){

			}finally{
				this.isFetching = false;
			}
		},
		getCompareFunc():(a:DanglingDossierDb, b:DanglingDossierDb)=>boolean {
			return (a:DanglingDossierDb, b:DanglingDossierDb)=>{
				return a.dossierId == b.dossierId;
			};
		},
		openInfo(){
			let item = this.selectedItems[0];
			if (!item) return;
			if (!item.companyId) return;
			this.$router.push(`/companies/${item.companyId}/info`);
		},
		async deleteDb(){
			let item = this.selectedItems[0];
			if (!item) return;
			if (this.isDeleting) return;
			try{
				this.isDeleting = true;
				let confirm = await this.$wf.confirm(`Weet je zeker dat je dossier_${item.dossierId} wilt verwijderen?`, "Ja", "Nee", "Waarschuwing", "danger");
				if (!confirm) return;
				await ServerService.dbService.deleteDossierDb(this.dbId, item.dossierId);
				this.selectedItems.splice(0, this.selectedItems.length);
				let i = this.dbs.findIndex(db=>db.dossierId == item.dossierId);
				if (i == -1) return;
				this.dbs.splice(i,1);
			}catch(err){

			}finally{
				this.isDeleting = false;
			}
		}
	},
	async mounted(){
		this.dbId = parseInt(this.$route.params.id);
		let dbs = await MetricService.getAllDbIds();
		for (let db of dbs) {
			if (db.id == this.dbId){
				this.dbInfo = db;
				break;
			}
		}
		if (!this.dbInfo){
			this.$wf.notify(`${this.$route.params.id} is geen valide db id`);
			this.$router.push("/");
		}
		await this.fetch();
	}
});
